import type { TFunction } from "i18next";
import React from "react";
import { View } from "react-native";

import styles from "../screens/DiaryViewScreenStyles";
import MacroTargetInfo from "./MacroTargetInfo";

interface NutritionOverviewProps {
  actualKcalsForTheDay: number;
  targetKcalsForTheDay: number;
  actualProteinForTheDay: number;
  targetProteinForTheDay: number;
  actualFatForTheDay: number;
  targetFatForTheDay: number;
  actualCarbsForTheDay: number;
  targetCarbsForTheDay: number;
  t: TFunction;
  shouldShowTargetMacros: boolean;
}

const NutritionOverviewForTheDay = ({
  actualKcalsForTheDay,
  targetKcalsForTheDay,
  actualProteinForTheDay,
  targetProteinForTheDay,
  actualFatForTheDay,
  targetFatForTheDay,
  actualCarbsForTheDay,
  targetCarbsForTheDay,
  t,
  shouldShowTargetMacros,
}: NutritionOverviewProps): JSX.Element => (
  <View testID={"diaryViewScreen-nutrition-overview"}>
    <View style={styles.macroOverviewTargetContainer}>
      <MacroTargetInfo
        title={t("general.kcal_short")}
        actualValue={actualKcalsForTheDay}
        targetValue={targetKcalsForTheDay}
        showTarget={shouldShowTargetMacros}
      />
      <MacroTargetInfo
        title={t("general.protein_short")}
        actualValue={actualProteinForTheDay}
        targetValue={targetProteinForTheDay}
        style={styles.proteinForTheDayText}
        showTarget={shouldShowTargetMacros}
      />
    </View>

    <View style={styles.macroOverviewTargetContainer}>
      <MacroTargetInfo
        title={t("general.fat")}
        actualValue={actualFatForTheDay}
        targetValue={targetFatForTheDay}
        showProgressBar={false}
        showTarget={shouldShowTargetMacros}
      />
      <MacroTargetInfo
        title={t("general.carbohydrates_short")}
        actualValue={actualCarbsForTheDay}
        targetValue={targetCarbsForTheDay}
        showProgressBar={false}
        showTarget={shouldShowTargetMacros}
      />
    </View>
  </View>
);

export const MemoizedNutritionOverviewForTheDay = React.memo(NutritionOverviewForTheDay);
export default NutritionOverviewForTheDay;
